import { configureStore } from '@reduxjs/toolkit';

import reducers from './reducers.js';

export default (function configure() {
  const store = configureStore({
    reducer: reducers
  });

  return store;
})();
